import { InputNumber, Tag } from 'antd'

import { useContext } from 'react'
import { faClock, faDollarSign } from '@fortawesome/pro-solid-svg-icons'

import FormItem from './FormItem'
import { InstitutionContext } from '../../../Providers/InstitutionProvider'
import { isObject } from '../../../utils'
import { InstitutionOptions } from '../../../utils/constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { isBoolean } from 'lodash'

const InternshipDurationItem = ({ disabled, duration, compensation, onDurationChange, onCompensationChange }) => {
  const { options } = useContext(InstitutionContext) ?? {}

  const useCompensation = isObject(options) && options[InstitutionOptions.INTERNSHIP_COMPENSATION]

  return (
    <FormItem icon={faClock} label='form.label.internship_duration'>
      <div className='flex-row' style={{ width: '100%', alignItems: 'center' }}>
        <InputNumber
          min={0}
          style={{ width: useCompensation && isBoolean(compensation) ? 'calc(100% - 38px)' : '100%' }}
          value={duration}
          onChange={onDurationChange}
          disabled={disabled}
        />
        {useCompensation && isBoolean(compensation) && (
          <Tag style={{ height: '30px', width: '30px', marginLeft: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} color={compensation ? 'green' : 'red'} onClick={() => onCompensationChange(!compensation)}>
            <FontAwesomeIcon icon={faDollarSign} />
          </Tag>
        )}
      </div>
    </FormItem>
  )
}

export default InternshipDurationItem
